export var SupportedLanguage;
(function (SupportedLanguage) {
    SupportedLanguage["EN"] = "en";
    SupportedLanguage["DE"] = "de";
    SupportedLanguage["RU"] = "ru";
    SupportedLanguage["PL"] = "pl";
})(SupportedLanguage || (SupportedLanguage = {}));
export const EMAIL_SUBJECTS = {
    [SupportedLanguage.EN]: {
        EMAIL_VERIFICATION: 'Verify your email address - mygate',
        TRANSACTION_CONFIRMATION: 'Transaction Confirmation - mygate',
        SECURITY_ALERT: 'Security Alert - mygate',
        KYC_STATUS_UPDATE: 'KYC Status Update - mygate',
        ACCOUNT_DELETION_REQUEST: 'Account Deletion Request Received - mygate',
        ACCOUNT_DELETION_ADMIN: 'Account Deletion Request - Action Required',
        STANDING_ORDER_GENERATION_REPORT: 'Standing Order Generation Report - mygate',
        WITHDRAWAL_RECEIVED: 'Withdrawal received - mygate',
        WITHDRAWAL_ADMIN: 'Withdrawal Declared - Action Required',
        TRADEVEST_CANCELLATION_RECEIVED: 'Cancellation received - mygate',
        TRADEVEST_CANCELLATION_ADMIN: 'Tradevest Cancellation - Action Required',
        KYC_MANUAL_REVIEW_ADMIN: 'KYC Manual Review Required - Action Required',
        PAYCENTER_TRANSFER_NOT_ALLOWED_ADMIN: 'PayCenter Transfer Refused - Action Required',
        EMAIL_ADDRESS_CHANGED: 'Your email address was changed - mygate',
        TRADEVEST_ORDER_EXECUTED: 'Your order was executed - mygate',
        TRADEVEST_ORDER_FAILED: 'Your order could not be executed - mygate',
        TRADEVEST_ORDER_PLACED: 'We received your order - mygate',
    },
    [SupportedLanguage.DE]: {
        EMAIL_VERIFICATION: 'Bestätigen Sie Ihre E-Mail-Adresse - mygate',
        TRANSACTION_CONFIRMATION: 'Transaktionsbestätigung - mygate',
        SECURITY_ALERT: 'Sicherheitswarnung - mygate',
        KYC_STATUS_UPDATE: 'KYC-Status-Update - mygate',
        ACCOUNT_DELETION_REQUEST: 'Kontolöschungsantrag erhalten - mygate',
        ACCOUNT_DELETION_ADMIN: 'Account Deletion Request - Action Required',
        STANDING_ORDER_GENERATION_REPORT: 'Dauerauftrag Generierungsbericht - mygate',
        WITHDRAWAL_RECEIVED: 'Widerruf erhalten - mygate',
        WITHDRAWAL_ADMIN: 'Withdrawal Declared - Action Required',
        TRADEVEST_CANCELLATION_RECEIVED: 'Kündigung erhalten - mygate',
        TRADEVEST_CANCELLATION_ADMIN: 'Tradevest Cancellation - Action Required',
        KYC_MANUAL_REVIEW_ADMIN: 'KYC Manual Review Required - Action Required',
        PAYCENTER_TRANSFER_NOT_ALLOWED_ADMIN: 'PayCenter Transfer Refused - Action Required',
        EMAIL_ADDRESS_CHANGED: 'Ihre E-Mail-Adresse wurde geändert - mygate',
        TRADEVEST_ORDER_EXECUTED: 'Deine Order wurde ausgeführt - mygate',
        TRADEVEST_ORDER_FAILED: 'Deine Order konnte nicht ausgeführt werden - mygate',
        TRADEVEST_ORDER_PLACED: 'Wir haben deine Order erhalten - mygate',
    },
    [SupportedLanguage.RU]: {
        EMAIL_VERIFICATION: 'Подтвердите ваш адрес электронной почты - mygate',
        TRANSACTION_CONFIRMATION: 'Подтверждение транзакции - mygate',
        SECURITY_ALERT: 'Предупреждение безопасности - mygate',
        KYC_STATUS_UPDATE: 'Обновление статуса KYC - mygate',
        ACCOUNT_DELETION_REQUEST: 'Запрос на удаление аккаунта получен - mygate',
        ACCOUNT_DELETION_ADMIN: 'Account Deletion Request - Action Required',
        STANDING_ORDER_GENERATION_REPORT: 'Отчёт о генерации постоянных поручений - mygate',
        WITHDRAWAL_RECEIVED: 'Отзыв договора получен - mygate',
        WITHDRAWAL_ADMIN: 'Withdrawal Declared - Action Required',
        TRADEVEST_CANCELLATION_RECEIVED: 'Расторжение договора получено - mygate',
        TRADEVEST_CANCELLATION_ADMIN: 'Tradevest Cancellation - Action Required',
        KYC_MANUAL_REVIEW_ADMIN: 'KYC Manual Review Required - Action Required',
        PAYCENTER_TRANSFER_NOT_ALLOWED_ADMIN: 'PayCenter Transfer Refused - Action Required',
        EMAIL_ADDRESS_CHANGED: 'Ваш адрес электронной почты был изменён - mygate',
        TRADEVEST_ORDER_EXECUTED: 'Ваш ордер исполнен - mygate',
        TRADEVEST_ORDER_FAILED: 'Ваш ордер не был исполнен - mygate',
        TRADEVEST_ORDER_PLACED: 'Мы получили ваш ордер - mygate',
    },
    [SupportedLanguage.PL]: {
        EMAIL_VERIFICATION: 'Potwierdź swój adres e-mail - mygate',
        TRANSACTION_CONFIRMATION: 'Potwierdzenie transakcji - mygate',
        SECURITY_ALERT: 'Alert bezpieczeństwa - mygate',
        KYC_STATUS_UPDATE: 'Aktualizacja statusu KYC - mygate',
        ACCOUNT_DELETION_REQUEST: 'Prośba o usunięcie konta otrzymana - mygate',
        ACCOUNT_DELETION_ADMIN: 'Account Deletion Request - Action Required',
        STANDING_ORDER_GENERATION_REPORT: 'Raport generowania zleceń stałych - mygate',
        WITHDRAWAL_RECEIVED: 'Odstąpienie od umowy otrzymane - mygate',
        WITHDRAWAL_ADMIN: 'Withdrawal Declared - Action Required',
        TRADEVEST_CANCELLATION_RECEIVED: 'Wypowiedzenie otrzymane - mygate',
        TRADEVEST_CANCELLATION_ADMIN: 'Tradevest Cancellation - Action Required',
        KYC_MANUAL_REVIEW_ADMIN: 'KYC Manual Review Required - Action Required',
        PAYCENTER_TRANSFER_NOT_ALLOWED_ADMIN: 'PayCenter Transfer Refused - Action Required',
        EMAIL_ADDRESS_CHANGED: 'Twój adres e-mail został zmieniony - mygate',
        TRADEVEST_ORDER_EXECUTED: 'Twoje zlecenie zostało zrealizowane - mygate',
        TRADEVEST_ORDER_FAILED: 'Twoje zlecenie nie zostało zrealizowane - mygate',
        TRADEVEST_ORDER_PLACED: 'Otrzymaliśmy Twoje zlecenie - mygate',
    },
};
//# sourceMappingURL=language.types.js.map